import { MenuItemBreadcrumbs } from '@/routes/MenuItem'
import ROUTER from '@/routes/ROUTER'
import { findParent, treeToList } from '@/shared/utils/utils'
import { Breadcrumb } from 'antd'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import styled from 'styled-components'

const BreadcrumbHomeStyle = styled.div`
  .ant-breadcrumb-link {
    font-weight: 400 !important;
    cursor: pointer;
    font-size: 14px;
    color: #666 !important;
    &:hover {
      color: var(--main-color) !important;
    }
  }

  li:last-child {
    .ant-breadcrumb-link {
      cursor: unset;
      font-weight: 600 !important;
      color: #333 !important;
    }
  }
  .breadcrumb-header {
    background-color: transparent !important;
    box-shadow: unset;
  }
  .ant-breadcrumb-separator {
    color: #999 !important;
  }
`

interface BreadcrumbHomeProps {
  className?: string
}

const treeLabel = (tree: any[]): any[] | undefined => {
  if (tree?.length <= 0) return
  return tree?.map((i: any) => ({
    ...i,
    title: i?.label,
    children: treeLabel(i?.children),
  }))
}

const BreadcrumbHome = ({ className = '' }: BreadcrumbHomeProps) => {
  const location = useLocation()
  const pathSpecial = [ROUTER.QUAN_LY_PHAN_QUYEN]?.find((i: any) => location?.pathname?.includes(i))
  const locationPathName = pathSpecial ? pathSpecial : location?.pathname
  const navigate = useNavigate()

  const [listParent, setListParent] = useState<any[]>([])

  useEffect(() => {
    const items = treeLabel(MenuItemBreadcrumbs())
    const parents =
      findParent({ children: items }, `${locationPathName}${location?.search}`) ||
      findParent({ children: items }, `${locationPathName}`)

    setListParent(
      treeToList([parents])
        .reverse()
        ?.filter((i: any) => i?.label)
    )
  }, [location, locationPathName])

  return (
    <BreadcrumbHomeStyle className={className}>
      {listParent?.length > 0 && (
        <div className="box-breadcrumb-header">
          <div className="breadcrumb-header">
            <Breadcrumb separator=">">
              {/* <Breadcrumb.Item
                  style={{
                    cursor: 'pointer',
                  }}
                  href={ROUTER?.HOME}
                >
                  Trang chủ
                </Breadcrumb.Item> */}
              {listParent?.map((i: any, idx: number) => (
                <Breadcrumb.Item
                  style={{
                    cursor:
                      !i?.key?.includes('subkey') && idx !== listParent?.length - 1
                        ? 'pointer'
                        : 'unset',
                  }}
                  onClick={() => {
                    if (i?.state) {
                      navigate(
                        i?.key?.includes('subkey') || idx === listParent?.length - 1
                          ? undefined
                          : i?.key,
                        { state: i?.state }
                      )
                    } else {
                      navigate(
                        i?.key?.includes('subkey') || idx === listParent?.length - 1
                          ? undefined
                          : i?.key
                      )
                    }
                  }}
                  key={i?.key}
                >
                  {i?.label}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          </div>
        </div>
      )}
    </BreadcrumbHomeStyle>
  )
}

export default BreadcrumbHome
